import React from 'react'

const site = JSON.parse(localStorage.getItem('site'))
const acc = JSON.parse(localStorage.getItem('acc'))

import { ReactComponent as OperationFacturation } from '../assets/svg/Header/OperationFacturation.svg'
import { ReactComponent as OperationCredentials } from '../assets/svg/Header/OperationCredentials.svg'
import { ReactComponent as OperationDebtors } from '../assets/svg/Header/OperationDebtors.svg'
import { ReactComponent as OperationTPOPAM } from '../assets/svg/Header/OperationTPOPAM.svg'


export const billings = [
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/history',
    name: 'Invoicing',
    icon: <OperationFacturation width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/debtors',
    name: 'Debtors',
    icon: <OperationDebtors width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.juise,
    link: '/admin/supDebt',
    name: `Suppliers Credentials`,
    icon: <OperationCredentials width={'30px'} height={'30px'}/>,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.juise,
    link: 'https://tpoapp.com/agent/TPOPAM',
    name: `Daily Payments`,
    icon: <OperationTPOPAM width={'30px'} height={'30px'}/>,
    enabled: true,
    disabled: false,
  },
]
